// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"7fd14e93f99ce0b2d90e","mat-icons":"d06e39a2eb59e1d70ffc"}[chunkId] + ".css";
};